// extracted by mini-css-extract-plugin
export var cardLayout = "_5t-1";
export var paginationContainer = "_5t-0";